/* eslint-disable jsx-a11y/alt-text */

/* eslint-disable @next/next/no-img-element */
import { CogIcon } from '@heroicons/react/24/outline'
import { NextPage } from 'next'
import Layout from '~/src/components/Layout'

export const createDeepLinkToApp = (
  screen: string,
  id?: string,
  params?: string
): string => {
  const link = process.env.CUSTOM_APP_SCHEME || 'com.dupe.com.dev'
  return `${link}://${screen}${id ? `/${id}` : ''}${params ? `?${params}` : ''}`
}

export default (function UpdateIos() {
  return (
    <Layout
      key={'update-ios'}
      hideHeader
      hideFooter
      hideBorders
      nextSeo={{
        noindex: true,
        nofollow: true,
      }}
      fullWidth
      title='Safari Extension: Update iOS'
      backgroundTheme='#363283'
    >
      <div className='mx-6 my-8 flex flex-col space-y-10'>
        <div>
          <img
            src='/images/safari-onboarding/toolbar-icon.png'
            className='h-[19px] w-auto'
          />
          <div className='mt-4 max-w-xs text-xl font-semibold dark:text-gray-50'>
            Dupe mobile extension is only available on iOS 15.5 or later
          </div>
          <img
            src='/images/safari-onboarding/safari-icon.png'
            className='mx-auto my-5 flex w-full max-w-xs items-center justify-center'
          />
          <div className='mt-5 text-gray-400 dark:text-gray-200'>
            Open your iPhone settings and navigate to{' '}
            <span className='dark:yellow-300 space-x-1 whitespace-nowrap bg-yellow-100 font-mono text-sm font-semibold dark:text-gray-500'>
              <CogIcon className='relative bottom-[1px] inline h-4 w-4 text-gray-400' />
              <span>General &gt; Software update</span>
            </span>{' '}
            to update your iOS version
          </div>
        </div>

        <a
          href={createDeepLinkToApp('/', undefined, `safari-extension-popup`)}
          target='_blank'
          rel='noreferrer'
          className='w-full rounded-md bg-black py-4 text-center font-semibold text-white dark:bg-white dark:text-black'
        >
          Take me back to Dupe
        </a>
      </div>
    </Layout>
  )
} as NextPage)
